import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import PropTypes from "prop-types"
import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography
} from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 272
  },
  cardTitle: {
    fontFamily: "Ubuntu",
    fontSize: 23,
    fontWeight: 700,
    textTransform: "uppercase",
    display: "block"
  },
  money: {
    fontFamily: "Ubuntu",
    fontSize: 80,
    fontWeight: 700,
    display: "block",
    lineHeight: "80px"
  },
  spaceY: {
    margin: theme.spacing(2, 0)
  }
  // spaceB: {
  //   marginBottom: theme.spacing(2)
  // },
  // spaceT: {
  //   paddingTop: theme.spacing(2)
  // }
}))

export default function CardsInvestment(props) {
  const classes = useStyles()

  return (
    <Grid item>
      <Card className={classes.root}>
        <CardActionArea>
          <CardContent>
            <Typography
              variant="h3"
              align="center"
              className={classes.cardTitle}
            >
              {props.title}
            </Typography>
            <Typography variant="body1" align="center">
              {props.union}
            </Typography>
            <Typography
              variant="body1"
              align="center"
              color={props.color}
              className={classes.money}
            >
              {props.number}
            </Typography>
            <Typography
              variant="body1"
              color="textSecondary"
              align="center"
              component="p"
              className={classes.spaceB}
            >
              {props.content1}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              align="center"
              component="p"
              className={classes.spaceY}
            >
              {props.content2}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              align="center"
              component="p"
            >
              <span>{props.content3}</span>
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  )
}
CardsInvestment.propTypes = {
  title: PropTypes.string,
  number: PropTypes.string,
  content1: PropTypes.string,
  content2: PropTypes.string,
  content3: PropTypes.string,
  union: PropTypes.string,
  prestamo: PropTypes.string
}
